<template>
	<div id="app">
		<router-view name="leftBar"></router-view>
		<div class="right-wrap">
			<router-view name="topBar"></router-view>
			<div class="overflow-wrap" :class="$route.name">
				<ul class="bread-crumb" v-if="$route.name && !$route.name.toLowerCase().includes('login')">
					<li>{{breadcrumb[0]}}</li>
					<li>{{breadcrumb[1]}}</li>
					<li v-if="breadcrumb[2]" class="desc">{{breadcrumb[2]}}</li>
				</ul>
				<transition name="fade" mode="out-in">
					<router-view class="view"></router-view>
				</transition>
				<footer>
					<div v-if="$route.name && $route.name.toLowerCase().includes('login')" style="margin: 30px 0px 20px;">
						<span class="footer-url-one">
							<a href="//www.yunban.com" target="_blank">云瓣校园</a>
						</span>
						<span class="footer-url-one">
							<a href="//d.yunban.com" target="_blank">云瓣电子校园卡</a>
						</span>
						<span class="footer-url-one">
							<a href="//s.yunban.com" target="_blank">云瓣商家中心</a>
						</span>
						<span class="footer-url-one">
							<a href="//jft.yunban.com" target="_blank">云瓣缴费通</a>
						</span>
					</div>
					<div>Copyright © 2012 - {{ currentYear }} Yunban. All Rights Reserved.
						<template v-if="$route.name && $route.name.toLowerCase().includes('login')">云瓣科技有限公司版权所有</template>
						<template v-else>
							<a href="//www.yunban.com" target="_blank" rel="noopener noreferrer">云瓣科技有限公司版权所有</a>
						</template>
						<template>
							沪ICP备14019811号-2 <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013871" target="_blank">沪公网安备 31011502013871号<img class="police" src="./assets/police.png" alt/></a>
						</template>
					</div>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
	name: "App",
	computed: {
		...mapState(["breadcrumb"])
	},
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
};
</script>

<style lang="scss">
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	outline: 0;
	font-family: tahoma, PingFang SC, microsoft yahei, arial, helvetica neue,
		hiragino sans gb, sans-serif !important;
}
html {
	font-family: tahoma, PingFang SC, microsoft yahei, arial, helvetica neue,
		hiragino sans gb, sans-serif !important;
	color: #666;
	font-size: 14px;
}
body {
	line-height: 1.5;
	font-family: tahoma, PingFang SC, microsoft yahei, arial, helvetica neue,
		hiragino sans gb, sans-serif !important;
}
ul {
	list-style: none;
}
#app {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	background-color: #f0f2f5;
}

.right-wrap {
	flex: 1;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow-x: auto;
	z-index: 1;
}
.right-wrap > .overflow-wrap {
	flex: 1;
	overflow-y: auto;
	min-width: 1000px;
	&.login {
		background-color: #fff;
		min-width: 1440px;
	}
}
.bread-crumb {
	background-color: #fff;
	padding: 15px 32px;
	li:first-child {
		color: RGBA(0, 0, 0, 0.45);
		font-size: 14px;
		line-height: 22px;
	}
	li:nth-child(2) {
		color: RGBA(0, 0, 0, 0.85);
		font-size: 20px;
		line-height: 28px;
		margin-top: 10px;
	}
	li.desc {
		margin-top: 16px;
		height: 22px;
		font-size: 14px;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
		line-height: 22px;
	}
}

footer {
	text-align: center;
	margin: 30px 0;
	font-size: 12px;
	color: rgba(0, 0, 0, 0.45);
	a {
		text-decoration: none;
		color: rgba(0, 0, 0, 0.45);
		&:hover {
			color: #108ee9;
		}
	}
	.footer-url-one {
		position: relative;
		padding: 0 15px;
		&:before {
			content: "";
			position: absolute;
			top: 2px;
			right: 0;
			width: 1px;
			height: 10px;
			background-color: rgba(0, 0, 0, 0.3);
		}
		&:last-child::before {
			content: none;
		}
	}
}
.view {
	flex: 1;
	display: flex;
	flex-direction: column;
	margin: 25px;
	border-radius: 2px;
}
.el-checkbox {
	font-weight: 400;
}
// message-box样式修改
.el-message-box {
	border: 0 !important;
	width: 480px !important;
	padding-bottom: 12px !important;
	.el-message-box__header {
		padding: 14px;
		font-weight: 500;
		border-bottom: 1px solid #e9e9e9;
		.el-message-box__title {
			font-size: 14px;
			line-height: 20px;
			color: #333;
		}
	}
	.el-message-box__content {
		padding: 35px 15px 30px 15px;
		.el-message-box__status.el-icon-warning {
			color: #f5222d;
			// width: 32px;
			// height: 32px;
			// background: url(./assets/warning.svg) 100% / 100% no-repeat;
		}
		.el-input__inner {
			color: rgba(0, 0, 0, 0.65);
		}
	}
	.el-message-box__btns {
		border-top: 1px solid #e9e9e9;
		padding-top: 12px;
		.el-button--small {
			width: 74px;
		}
		.el-button--primary {
			background-color: #1890ff;
		}
	}
}
//
.ant-select-selection {
	.ant-select-selection__placeholder,
	.ant-select-search__field__placeholder {
		color: rgba(0, 0, 0, 0.65);
	}
}

// dialog
.el-dialog {
	.el-dialog__header {
		padding: 14px 20px;
		font-weight: 500;
		border-bottom: 1px solid #e9e9e9;
		.el-dialog__title {
			font-size: 14px;
			line-height: 20px;
		}
		.el-dialog__headerbtn {
			top: 6px;
		}
	}
	.el-dialog__body {
		textarea {
			min-height: 88px !important;
		}
		.el-form {
			.el-form-item:last-child {
				margin-bottom: 0;
			}
		}
	}
	.el-dialog__footer {
		border-top: 1px solid #e9e9e9;
		padding-top: 12px;
		padding-bottom: 12px;
		.el-button--small {
			min-width: 74px;
		}
	}
}
// 固定table-plugins输入框宽度
.table-plugins {
	.daterange {
		width: 210px;
		margin-right: 20px;
	}
	.input-cardNo {
		width: 210px;
		margin-right: 20px;
	}
}
// 修改Safari下光标过高问题
.el-date-editor--daterange.el-input__inner {
	.daterange {
		.el-range-input {
			line-height: 24px !important;
		}
	}
}
// 修改Safari下光标过高问题
.el-input--small .el-input__inner {
	line-height: 24px !important;
}

// 表格tooltip样式覆盖
.el-tooltip__popper.is-dark {
	background: rgba(0, 0, 0, 0.75) !important;
	.popper__arrow ::after {
		border-top-color: rgba(0, 0, 0, 0.75) !important;
	}
}
// table 表头高亮
.table-header th {
	padding: 10px 0;
	background-color: #fafafa;
	color: rgba(0, 0, 0, 0.85);
}
// 表格CheckBox禁用样式覆盖
.el-checkbox__input.is-disabled .el-checkbox__inner {
	background-color: #f5f5f5;
}
// 表格操作列中间分割线
.cell {
	.line {
		color: #d8d8d8;
	}
	.el-button + .el-button {
		margin-left: 0;
	}
	.el-icon-arrow-down.el-icon--right {
		color: #1890ff;
	}
	&.el-tooltip::before {
		content: "";
		// display: block;
	}
}
// 表格筛选框间隔
.filter-wrap {
	.el-checkbox + .el-checkbox {
		margin-top: 10px;
	}
}
// 下拉框箭头样式调整
.el-popper[x-placement^="bottom"] {
	margin-top: 4px;
}
.el-select-dropdown.el-popper,
.el-cascader-menus.el-popper,
.el-dropdown-menu.el-popper {
	padding: 10px 1px;
	.el-icon-arrow-down.el-icon--right {
		color: #1890ff;
	}
	.popper__arrow {
		display: none;
	}
}
.el-autocomplete-suggestion.el-popper {
	.el-icon-arrow-down.el-icon--right {
		color: #1890ff;
	}
	.popper__arrow {
		display: none;
	}
}
//分页样式调整
.el-pagination {
	font-weight: 400;
	.el-pagination__jump {
		margin-left: 0;
	}
	.el-pagination__total {
		float: left;
		color: rgba(0, 0, 0, 0.45);
	}
}
// tooltips
.group-popover,
.nav-popover {
	border: 0;
	background: rgba(0, 0, 0, 0.75);
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
	border-radius: 4px;
	padding: 5px 13px;
	font-size: 14px;
	line-height: 22px;
	min-width: 90px;
	color: #fff;
	text-align: center;
	cursor: pointer;
	.popper__arrow {
		&::after {
			border-top-color: rgba(0, 0, 0, 0.75) !important;
		}
	}
}

// 权限组左对齐
.el-form-item__content {
	.el-checkbox-group {
		.el-checkbox {
			width: 100px;
			margin-right: 30px;
		}
		.el-checkbox + .el-checkbox {
			margin-left: 0;
		}
	}
}

// 校园卡样式覆盖
.ecard {
	.el-upload--picture-card {
		width: 200px;
		height: 126px;
		line-height: 126px;
	}
	.el-upload-list--picture-card .el-upload-list__item {
		width: 200px;
		height: 126px;
	}
	.el-upload-list__item.is-success .el-upload-list__item-status-label,
	.el-upload-list.is-disabled
		.el-upload-list__item:hover
		.el-upload-list__item-status-label {
		display: none;
	}
}
.hide-upload-btn {
	.el-upload--picture-card {
		display: none;
	}
}

.upload-wrap {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	.el-upload__text {
		height: 24px;
		font-size: 14px;
		line-height: 24px;
		color: rgba(0, 0, 0, 0.45);
	}
	.el-upload__tip {
		margin-top: 0;
		height: 24px;
		font-size: 12px;
		color: rgba(0, 0, 0, 0.25);
		line-height: 24px;
	}
}
// button 样式覆盖
.el-button--primary {
	background-color: #108ee9 !important;
	border-color: #108ee9 !important;
	&:focus,
	&:hover {
		background: #0780d8 !important;
		border-color: #0780d8 !important;
	}
	&.is-active,
	&:active {
		background: #31a8ff !important;
		border-color: #31a8ff !important;
	}
	&.is-disabled {
		color: rgba(0, 0, 0, 0.65);
		background: #f5f5f5 !important;
		border-color: #d9d9d9 !important;
	}
}
.el-button--primary.is-plain {
	background-color: #ecf5ff !important;
}

// 表单按钮宽度限制，间隔限制
.el-form-item {
	margin-bottom: 32px;
	.el-button--small {
		width: 80px;
	}
}
.el-button--small {
	font-size: 14px;
	padding: 8px 15px;
}

.pull-left {
	float: left;
	height: 100%;
	display: flex;
	align-items: center;
}

.pull-right {
	float: right;
	height: 100%;
	display: flex;
	align-items: center;
}

.fade-enter-active,
.fade-leave-active {
	transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
.el-table {
	-ms-flex: none;
}
.police {
	width: 24px;
	padding: 0px 4px 2px;
	position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue